<template>
    <v-flex v-if="businessInterests.Business || isCurrentUser">
        <v-flex tag="h2">{{memberProfileConstants.BUSINESS_EXPERTISE}}<i v-if="isCurrentUser" class="fas fa-pencil-alt ml-2" data-qe-id ="businessInterests_edit" @click="openDialog()"></i>
        </v-flex>
        <v-flex class="business-expertise inner-scrollbar">
            <status-overlay :action="loadGetBusinessInterestsAction" content-height="200px">
            </status-overlay>
            <v-flex class="default_text" v-if="(!interests || !Object.keys(interests).length>0) && isCurrentUser">{{memberProfileConstants.DEFAULT_EDIT_TEXT.BUSINESS_EXPERTISE}}</v-flex>
            <v-flex v-for="interestKey in Object.keys(interests).sort()" :key="interestKey">
                <v-layout row wrap class="category">
                    <v-flex xs6 tag="strong">{{interestKey}}</v-flex>
                    <v-flex xs3 class="experienced">{{memberProfileConstants.EXPERIENCED}}</v-flex>
                    <v-flex xs3 text-xs-center>{{memberProfileConstants.INTERESTED}}</v-flex>
                </v-layout> 
                <v-flex v-for="(business, index) in interests[interestKey]" :key="index">
                    <v-layout row wrap class="options">
                        <v-flex xs6>{{business.subCategoryName}}</v-flex>
                        <v-flex xs3 class="custombox experienced">
                            <input
                                id="checkbox_experienced"
                                data-qe-id="checkbox_experienced"
                                type="checkbox"
                                :checked="business.expertise"
                            />
                            <span class="checkmark"></span>
                        </v-flex>
                        <v-flex xs3 class="custombox interested">
                            <input
                                id="checkbox_interested"
                                data-qe-id="checkbox_interested"
                                type="checkbox"
                                :checked="business.interest"
                            />
                            <span class="checkmark"></span>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-flex>
        </v-flex>
        <v-dialog scrollable v-model="businessDialog" content-class="medium">
            <v-card class="myprofile-popup">
                <v-card-title primary-title>
                    {{memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.EDIT_BUSINESS_EXPERTISE}}
                    <i class="fas fa-times" data-qe-id ="editBusinessInterests_closeBtn1" @click="closeBusinessDialog()"></i>
                </v-card-title>            
                <v-card-text class="business-expertise inner-scrollbar" ref="businessExpertiseId">
                    <v-flex class="desc ma-3">{{memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.BUSINESS_DESC}}</v-flex>
                    <v-flex >
                        <v-expansion-panels v-model="businessExpertisePanel">
                        <v-expansion-panel expand v-model="businessExpertisePanel" id="business-expansion-panel">
                            <v-expansion-panel-content v-for="interestKey in Object.keys(businesses).sort()" :key="interestKey" >
                        <div slot="header">
                        <v-layout row wrap class="category">
                            <v-flex xs6 tag="strong">{{interestKey}}</v-flex>
                            <v-flex xs3 class="experienced">{{memberProfileConstants.EXPERIENCED}}</v-flex>
                            <v-flex xs3 text-xs-center>{{memberProfileConstants.INTERESTED}}</v-flex>
                        </v-layout>
                        </div>
                        <v-flex v-for="(business, index) in businesses[interestKey]" :key="index">
                            <v-layout row wrap class="options"> 
                                <v-flex xs6>{{business.subCategoryName}}</v-flex>
                                <v-flex xs3 class="custombox experienced">
                                    <v-checkbox color="ypo_blue" :data-qe-id ="'editBusinessInterests_experienced_' +index" v-model="business.expertise" v-on:change="changeInterest(business)"></v-checkbox>
                                </v-flex>
                                <v-flex xs3 class="custombox interested">
                                    <v-checkbox color="ypo_gold" :data-qe-id ="'editBusinessInterests_Interested_' +index" v-model="business.interest" v-on:change="changeInterest(business)"></v-checkbox>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
                    </v-flex>
                </v-card-text>
                <status-bar :action="saveInterestsAction"></status-bar>
                <v-card-actions>
                    <v-flex text-xs-right pa-3>
                        <v-flex>
                            <v-btn class="primary_btn transparent" data-qe-id ="editBusinessInterests_cancelBtn1" @click="cancel()">{{appCommonConstants.CANCEL}}</v-btn>
                            <v-btn class="primary_btn" :disabled="isDisabled" data-qe-id ="editBusinessInterests_save" @click="saveBusinessInterests()">{{appCommonConstants.DONE}}</v-btn>
                        </v-flex>
                    </v-flex>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-flex>
</template>

<script>
    import { mapState, mapActions, mapGetters } from "vuex";
    import { storeAction } from "../../store/storeActions.constant";
    import { storeGetters } from "../../store/storeGetters.constant";
    import { memberProfileConstants } from "./memberProfile.constants.js";
    import { appCommonConstants } from "../appCommon.constants.js";
    import StatusBar from "../StatusBar/StatusBar";
    import { eventBus } from '../../main';
    import StatusOverlay from '../StatusOverlay/StatusOverlay';
    import { uuid } from 'vue-uuid';
    import { gaDataLayerEvent } from "@/plugins/analytics";
    import { gtmEventName } from "@/plugins/gtmAnalytics";

    export default {
        name: "BusinessExpertiseInterest",
        data: () => ({
            memberProfileConstants,
            appCommonConstants,
            interests: [],
            businesses: [],
            businessDialog: false,
            isDisabled: true,
            changedCatgories: [],
            uuid: uuid.v1(),
            businessExpertisePanel: [],
        }),
        components: {
            StatusBar,
            StatusOverlay,
        },
        props: {
            memberId: {
                type: String,
                required: true,
            },
        },
        created() {
            this.businessExpertisePanel = [1];
            if (this.actions.getFamilyInterests && !this.actions.getFamilyInterests.pending) {
                this.getFamilyInterests(this.memberId);
            }
            setTimeout(() => {
                this.getBusinessInterests();
            }, 3000);
            eventBus.$on('businessDialog', ((value) => {
                this.businessDialog = value;
            }));
        },
        methods: {
            ...mapActions({
                getFamilyInterests: `memberProfile/${storeAction.getFamilyInterests}`,
                getBusinessInterests: `memberProfile/${storeAction.getBusinessInterests}`,
                savePersonInterests: `memberProfile/${storeAction.savePersonInterests}`,
            }),
            openDialog() {
                this.businessDialog = true;
                this.isDisabled = true;
            },
            cancel() {
                this.getBusinessInterests();
                this.changedCatgories = [];
                this.isDisabled = true;
                this.closeDialog();
                this.businessExpertisePanel = [1];
            },
            closeBusinessDialog() {
                this.getBusinessInterests();
                this.closeDialog();
            },
            closeDialog() {
                this.isDisabled = true;
                this.businessDialog = false;
                this.changedCatgories = [];
                this.scrollTop();
                this.businessExpertisePanel = [1];
            },
            changeInterest(interest) {
                this.isDisabled = false;
                const index = this.changedCatgories.indexOf(interest.categoryName);
                if (index === -1) {
                    this.changedCatgories.push(interest.categoryName);
                }
            },
            getInterests(val) {
                const arrInterests = [];
                if (val.Business) {
                    val.Business.forEach((x) => {
                        const list = arrInterests[x.categoryName];
                        if (list) {
                            const index = list.findIndex(y => y.subCategoryName === x.subCategoryName);
                            if (index !== -1) {
                                if (x.typePersonSkill === this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.INTEREST) {
                                    list[index].interest = x.isActivePersonSkill;
                                } else {
                                    list[index].expertise = x.isActivePersonSkill;
                                }
                            } else {
                                if (x.isActivePersonSkill === false) {
                                    return false;
                                }
                                list.push({ subCategoryName: x.subCategoryName, interest: (x.typePersonSkill === this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.INTEREST) ? x.isActivePersonSkill : false, expertise: (x.typePersonSkill === this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.EXPERTISE) ? x.isActivePersonSkill : false });
                            }
                        } else {
                            if (x.isActivePersonSkill === false) {
                                return false;
                            }
                            arrInterests[x.categoryName] = [{ subCategoryName: x.subCategoryName, interest: (x.typePersonSkill === this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.INTEREST) ? x.isActivePersonSkill : false, expertise: (x.typePersonSkill === this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.EXPERTISE) ? x.isActivePersonSkill : false }];
                        }
                    });
                }
                return arrInterests;
            },
            getInterestsTypes(val) {
                const arrBusinessInterests = [];
                Object.keys(val).forEach((key) => {
                    arrBusinessInterests[key] = [];
                    val[key].forEach((x) => {
                        if (this.interests[key]) {
                            const categoryExists = this.interests[key].some((el) => {
                                if (el.subCategoryName === x.subCategory) {
                                    return arrBusinessInterests[key].push({ 
                                        id: x.id, categoryName: key, subCategoryName: el.subCategoryName, interest: el.interest, expertise: el.expertise,
                                        });
                                }
                                return false;
                            });
                            if (!categoryExists) {
                                arrBusinessInterests[key].push({ 
                                    id: x.id, categoryName: key, subCategoryName: x.subCategory, interest: false, expertise: false,
                                    });
                            }
                        } else {
                            arrBusinessInterests[key].push({ 
                                id: x.id, categoryName: key, subCategoryName: x.subCategory, interest: false, expertise: false,
                                });
                        }
                    });
                });
                return arrBusinessInterests;
            },
            saveBusinessInterests() {  
                const saveInterest = [];  
                this.changedCatgories.forEach((key) => {
                    this.businesses[key].forEach((x) => {
                        if (this.businessInterests.Business) {
                            const expertIndex = this.businessInterests.Business.findIndex(y => y.subCategoryName === x.subCategoryName && y.categoryName === key && y.typePersonSkill === this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.EXPERTISE);
                            const interestIndex = this.businessInterests.Business.findIndex(y => y.subCategoryName === x.subCategoryName && y.categoryName === key && y.typePersonSkill === this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.INTEREST);
                            if (x.interest === true && x.expertise === true) {                                
                                if (expertIndex === -1) {
                                    saveInterest.push(this.prepareInterestObject(x, x.expertise, this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.EXPERTISE, key));
                                }          
                                if (interestIndex === -1) {
                                    saveInterest.push(this.prepareInterestObject(x, x.interest, this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.INTEREST, key));
                                }
                                this.UpdateExistingInterest(x, key, saveInterest);
                                return true;
                            } else if (x.expertise === true && x.interest === false) {
                                if (expertIndex === -1) {
                                    saveInterest.push(this.prepareInterestObject(x, x.expertise, this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.EXPERTISE, key));
                                }
                                this.UpdateExistingInterest(x, key, saveInterest);
                            } else if (x.interest === true && x.expertise === false) {
                                if (interestIndex === -1) {
                                    saveInterest.push(this.prepareInterestObject(x, x.interest, this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.INTEREST, key));
                                }
                                this.UpdateExistingInterest(x, key, saveInterest);
                            } else {
                                this.UpdateExistingInterest(x, key, saveInterest);
                            }
                        } else if (x.interest === true && x.expertise === false) {
                            saveInterest.push(this.prepareInterestObject(x, x.interest, this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.INTEREST));
                        } else if (x.expertise === true && x.interest === false) {
                            saveInterest.push(this.prepareInterestObject(x, x.expertise, this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.EXPERTISE));
                        } else if (x.expertise === true && x.interest === true) {
                            saveInterest.push(this.prepareInterestObject(x, x.interest, this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.INTEREST));
                            saveInterest.push(this.prepareInterestObject(x, x.expertise, this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.EXPERTISE));
                        }
                    });
                });
                if (saveInterest.length === 0) {
                    this.closeDialog();
                    return false;  
                }
                const postBody = { "Business": saveInterest };
                this.savePersonInterests(postBody)
                .then(() => {   
                    this.closeDialog();
                    gaDataLayerEvent(gtmEventName.C_Profile_Edit, `Interests - ${this.memberId}${this.isRedirectFromConnectPlus ? ' | Connect+ Redirect' : ''}`);
                });
            },
            UpdateExistingInterest(record, key, saveInterest) {
                this.businessInterests.Business.filter(x => x.categoryName === key && x.subCategoryName === record.subCategoryName)
                .forEach((el) => {
                    if (el.typePersonSkill === this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.INTEREST && record.interest !== el.isActivePersonSkill) {
                        saveInterest.push({ 
                                id: el.id, 
                                skillId: el.skillId, 
                                categoryName: el.categoryName, 
                                subCategoryName: el.subCategoryName, 
                                themeName: this.memberProfileConstants.BUSINESS,
                                typePersonSkill: this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.INTEREST,
                                isActivePersonSkill: record.interest,
                                personId: this.memberId,
                        });
                    } else if (el.typePersonSkill === this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.EXPERTISE && record.expertise !== el.isActivePersonSkill) {
                        saveInterest.push({ 
                                id: el.id, 
                                skillId: el.skillId, 
                                categoryName: el.categoryName, 
                                subCategoryName: el.subCategoryName, 
                                themeName: this.memberProfileConstants.BUSINESS,
                                typePersonSkill: this.memberProfileConstants.BUSINESS_EXPERTISE_INTEREST.EXPERTISE,
                                isActivePersonSkill: record.expertise,
                                personId: this.memberId,
                        });
                    }
                });
            },
            scrollTop() {
                if (this.$refs.businessExpertiseId) {
                    this.$refs.businessExpertiseId.scrollTop = 0;
                }
            },
            prepareInterestObject(data, personSkill, type, key) {
                return { 
                    id: uuid.v1(),
                    skillId: data.id,
                    categoryName: key || data.categoryName,
                    subCategoryName: data.subCategoryName,
                    themeName: this.memberProfileConstants.BUSINESS,
                    typePersonSkill: type,
                    isActivePersonSkill: personSkill,
                    personId: this.memberId,
                };
            },
        },
        computed: {
            ...mapState("actionState", ["actions"]),
            ...mapGetters({
                businessInterests: `memberProfile/${storeGetters.familyInterests}`,
                currentUserId: `memberProfile/${storeGetters.currentUserId}`,
                businessInterestsType: `memberProfile/${storeGetters.businessInterestTypes}`,
                chapterAdminEditable: `memberProfile/${storeGetters.chapterAdmin}`,
            }),
            isCurrentUser() {
                return this.memberId === this.currentUserId || this.chapterAdminEditable;
            },
            saveInterestsAction() {
                return this.actions[storeAction.savePersonInterests];
            },
            loadGetBusinessInterestsAction() {
                return this.actions[storeAction.getBusinessInterests];
            },
            isRedirectFromConnectPlus() {
              return this.$route && this.$route.query
                  && this.$route.query.connectPlusRedirect && this.$route.query.connectPlusRedirect === 'true';
            },
        },
        watch: {
            businessInterests(val) {
                this.interests = this.getInterests(val);
            },
            businessInterestsType(val) {
                this.businesses = this.getInterestsTypes(val);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import "../../common/styles/responsive.scss";


    .business-expertise {
        position: relative;
        max-height: 530px;
        overflow: auto;
        border-bottom: 1px solid $ypo-open-blue-gray;
        margin: 0 0 25px 0;
        padding: 0 20px 20px 20px;

        .default_text {
            margin-left: 20px;
        }

        .category {
            background-color: $ypo-prospect-tile-border;
            padding: 9px 0px 9px 10px;
            font-size: 14px;

            strong {
                color: $ypo-gray-text;
                display: block;
            }

            .experienced {
                position: relative;

                &:after {
                    content: "";
                    width: 1px;
                    height: 40px;
                    background: $ypo-medium-gray;
                    right: 0;
                    position: absolute;
                    top: -10px;
                }
            }
        }

        .options {
            margin: 20px 0 20px 13px;

            .custombox {
                display: block;
                position: relative;
                padding-left: 35px;
                margin-bottom: 12px;
                font-size: 22px;

                .checkmark {
                    position: absolute;
                    height: 20px;
                    width: 20px;
                    background-color: $ypo-medium-gray;
                    border-radius: 50%;
                    border: 1px solid $ypo-gray;
                }

                input {
                    position: absolute;
                    opacity: 0;
                    height: 0;
                    width: 0;

                    &:checked~.checkmark {
                        background-color: $ypo-gold;
                        border: 2px solid $ypo-gold;
                    }
                }

                &.experienced {
                    input {
                        &:checked~.checkmark {
                            background-color: $ypo_blue;
                            border: 2px solid $ypo_blue;
                        }
                    }
                }
            }
        }
    }
    
    .v-dialog {
        .business-expertise {
            margin-bottom: 0px;
            border-bottom: none;
            .options {
                margin:0 0 0 12px;
                .custombox {
                    text-align: center;
                    padding-left: 0;
                }
            }
            .category {
                .experienced {
                    text-align: center;
                    
                }
            }
        }
    }
    h2 {
        color: $ypo_blue;
        font-family: "Raleway", sans-serif;
        font-size: 22px;
        font-weight: 500;
        margin-bottom: 20px;
        line-height: 26px;
        padding-left: 20px;
    }    
    @include breakpoint(md) {
        h2 {
            padding-left: 0;
        }
        .business-expertise {
            padding: 0 0 20px 0;
            .category {
                font-size: 12px;
                font-weight: 600;
            }
        }
    }
    @include breakpoint(xs) {
        h2 {
            padding-left: 0;
        }
        .business-expertise {
            padding: 0 0 20px 0;
            .category {
                font-size: 10.5px;
                font-weight: 600;
            }
        }
    }
    @include breakpoint(sm) {
        .options{
            .custombox{
                &.interested{
                    padding-left: 80px;
                }
            }
        }
    }
    @include breakpoint(xs) {
        .options {
            .custombox {
                &.interested {
                    padding-left: 30px;
                }
            }
        }
    }
</style>
<style lang="scss">
    @import '../../common/styles/_colors.scss';

    .v-dialog {
        .business-expertise {
        .v-input--selection-controls {
            display: inline-block;
            margin: 0px;
            padding: 0px;
        }
    }
}
#business-expansion-panel .v-expansion-panel__header__icon {
        margin-right: 5px;
    }
    #business-expansion-panel .v-expansion-panel__header {
        padding: 0px;
        margin-left: 10px;
        margin-bottom: 10px;
        background-color: $ypo-prospect-tile-border;
    }
    .v-expansion-panel {
        box-shadow: 0px 2px 1px -1px rgba(0, 0, 0, 0), 0px 1px 1px 0px rgba(0, 0, 0, 0), 0px 1px 3px 0px rgba(0, 0, 0, 0);
    }
    .theme--light.v-expansion-panel .v-expansion-panel__container {
        border-top: 1px solid rgba(0, 0, 0, 0);
    }
</style>
